import React from 'react';

const HomeBlogPageHeader = () => {
    return (
        <div className="blog-home-hero">
            <div className="container">
                <div className="row">
                    <div className="blog-home-hero-content text-center col">
                        <h1>BLOG & NEWS</h1>
                        <p>There are many variations of passages of Lorem Ipsum available, but the dimbel have suffered
                            alteration</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeBlogPageHeader;
